var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact",attrs:{"id":"contact"}},[(!_vm.hideOrder)?_c('Order'):_vm._e(),_c('HouseInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }